import {PureComponent} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import 'rc-tooltip/assets/bootstrap.css' // ⚠️ / ℹ️ FIX tooltip style SHOULD BE IMPORTED FOR rc-tooltip

import FilterBar from "../../../../shared/components/FilterBar/FilterBar.jsx"
import SearchBar from '../../../components/SearchBar/SearchBar.jsx'
import SearchResultsPaginated from './SearchResultsPaginated.jsx'
import SubscribeBanner from '../../../components/SubscribeBanner/SubscribeBanner.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import DefaultLayout from '../../Layout/DefaultLayout.jsx'

import conf from '../../../conf.js'

class SearchResults extends PureComponent {
  static propTypes= {
    canToggleView: PropTypes.bool,
    currentUser: PropTypes.object,
    filters: PropTypes.object.isRequired,
    flattenSearchObject: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
    isAvailability: PropTypes.bool,
    isCity: PropTypes.shape({all: PropTypes.bool.isRequired, remote: PropTypes.bool.isRequired}),
    isLanguages: PropTypes.bool,
    isManager: PropTypes.bool,
    isOnlyMy: PropTypes.bool,
    isPrices: PropTypes.bool,
    isSecteurs: PropTypes.bool,
    isSkill: PropTypes.bool,
    isItSkills: PropTypes.bool,
    isFollowedByMe: PropTypes.bool,
    loading: PropTypes.bool,
    search: PropTypes.func.isRequired,
    renderResults: PropTypes.func.isRequired,
    searchRouteName: PropTypes.string.isRequired,
    searchQuery: PropTypes.object.isRequired,
    searchData: PropTypes.object.isRequired,
    topologies: PropTypes.array.isRequired,
    target: PropTypes.string.isRequired,
  }

  static defaultProps = {
    canToggleView: false,
    isAdmin: false,
    isAvailability: false,
    isCity: {all: false, remote: false},
    isLanguages: false,
    isManager: false,
    isOnlyMy: false,
    isPrices: false,
    isSecteurs: false,
    isSkill: false,
    isItSkills: false,
    isFollowedByMe: false,
    loading: true,
  }

  // generateLink = (search, offset) => generate({
  //   name: 'search.view',
  //   parameters: {offset, page: this.props.searchQuery.page},
  //   search: search
  // });

  render() {
    const {target} = this.props

    return (
      <DefaultLayout navbarContained={false} navbarSearch={false}>
        <div className="container-fluid container-search">
          <div id="search" className="row row-search">
            <div className="dashboard-search">
              <SearchBar
                onChange={this.props.search}
                canToggleView={this.props.canToggleView}
                searchQuery={this.props?.searchQuery ?? {}}
                filters={this.props.filters}
                target={this.props.target}
                topologies={this.props.topologies}
                resultsCount={this.props?.searchData?.pagination?.totalCount ?? 0}
                activeCount={this.props?.searchData?.activeCount ?? 0}
                conf={conf}
              />

              <FilterBar
                conf={conf}
                activeCount={this.props?.searchData.activeCount ?? 0}
                chart={this.props?.searchData?.chart ?? {}}
                isConnected={!!this.props.currentUser?.id}
                isAdmin={this.props.isAdmin}
                isAvailability={this.props.isAvailability}
                isCity={this.props.isCity}
                isLanguages={this.props.isLanguages}
                isManager={this.props.isManager}
                isOnlyMy={this.props.isOnlyMy}
                isPrices={this.props.isAdmin && this.props.isPrices}
                isSecteurs={this.props.isSecteurs}
                isSkill={this.props.isSkill}
                isItSkills={this.props.isItSkills}
                isFollowedByMe={this.props.isFollowedByMe}
                isFreelanceSearch={target === conf.search.targets.freelances}
                onChange={this.props.search}
                resultsCount={this.props?.searchData?.pagination?.totalCount ?? 0}
                searchData={this.props.searchData}
                searchQuery={this.props.searchQuery}
                topologies={this.props.topologies}
                target={this.props.target}
                currentUser={this.props.currentUser}
                filters={this.props.filters}/>

              <SubscribeBanner
                currentUser={this.props.currentUser}
                search={this.props.search}
                searchUniverseId={this.props?.currentUniverse?.id ?? null}
                target={this.props.target}
              />
              {this.props.loading ?
                <div className="p-5 p-relative">
                  <Loader visible={true} fill={false} contains={true} containsClassName="my-5">
                    Recherche en cours...
                  </Loader>
                </div> :
                <SearchResultsPaginated
                  className="search-results"
                  flattenSearchObject={this.props.flattenSearchObject}
                  pagination={this.props?.searchData?.pagination ?? {}}
                  renderResults={this.props.renderResults}
                  results={this.props?.searchData?.results?.length ? this.props?.searchData?.results : []}
                  routeName={this.props.searchRouteName}
                  searchQuery={this.props.searchQuery}
                />
              }
            </div>
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state.currentUser.user,
    searchData: state.search,
  }),
)(SearchResults)
